<template>
	<div>
		<div class="advwrap"></div>
		<div class="top-content">
			<!--<p class="money">¥2.00</p>-->
			<p><i class="weui-icon-success weui-icon_msg"></i>支付成功</p>
		</div>
		<div class="middle-content">
			<p>
				<span>商家订单号</span>
				<span>...</span>
			</p>
			<p>
				<span>订单号</span>
				<span>...</span>
			</p>
			<p>
				<span>车牌号</span>
				<span>...</span>
			</p>
			<p>
				<span>付款时间</span>
				<span>...</span>
			</p>
			<p>
				<span>进场时间</span>
				<span>...</span>
			</p>
			<p>
				<span>停车时长</span>
				<span>...</span>
			</p>
		</div>
		<!--<p class="tips">请在<span>15分钟内</span>（18:08之前）离场</p>-->
		<!--<div class="weui-btn-area">-->
			<!--<button class="weui-btn weui-btn_primary" @click="handleRation">开 票</button>-->
		<!--</div>-->
	</div>

</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    export default {
        name: "pay-success",
        computed: {
            ...mapGetters(['abParkId'])
        },
		mounted () {
            this.$getAdInfo(this.abParkId);
            // let mchData = {action:'onIframeReady',displayStyle:'SHOW_CUSTOM_PAGE'};
            // let postData = JSON.stringify(mchData);
            // parent.postMessage(postData,'https://payapp.weixin.qq.com');
            // window.addEventListener("message", function(e) {
            //     // alert(999)
            // });
		},
        methods: {
            ...mapMutations({
                setReceiptOrderSnObj: "SET_RECEIPT_ORDERSN_OBJ",
            }),
            handleRation () {
                this.$router.push({name:'userParkingFeeList'});
                this.$vnode.parent.componentInstance.cache = {};
                this.$vnode.parent.componentInstance.keys = [];
                this.setReceiptOrderSnObj({})
            }
        }
    }
</script>

<style scoped lang="stylus">
	.top-content{
		border-bottom 1px solid #e6e6e6
		padding 20px 0
		margin 0 20px
		display flex
		/*flex-direction column*/
		justify-content center
		/*align-items center*/
		.money{
			font-size 36px
			font-weight 500
			color #06ae56
		}
		p:last-child{
			padding-top 10px
			display flex
			align-items center
			.weui-icon-success{
				width 20px
				height: 20px;
			}
		}

	}
	.middle-content{
		padding 20px 20px 40px 20px
		p{
			display flex
			justify-content space-between
			padding-bottom 15px
		}
	}
	.tips{
		font-size 20px
		text-align center
		span{
			color #FFAE02
		}
	}
	.weui-btn-area{
		.weui-btn{
			width 100%
		}
	}
</style>

